/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeTourDetailResponseV3 } from '../../models/consignee-tour-detail-response-v-3';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeAddonsTourV3$Params {
  organizationSiteKey: KeyType;
  tourKey: KeyType;
}

export function getConsigneeAddonsTourV3(http: HttpClient, rootUrl: string, params: GetConsigneeAddonsTourV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeTourDetailResponseV3>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeAddonsTourV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeTourDetailResponseV3>;
    })
  );
}

getConsigneeAddonsTourV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/tours/{tourKey}';
